import { Checkbox, TextLink, Typography } from '@mgmresorts/mgm-ui';
import React, { useCallback, useMemo } from 'react';

import { CONTACT_US_URL } from '../../../../config/config.app';
import { BindCheckbox } from '../../../../hooks/useCheckbox';
import { useContent } from '../../../../hooks/useContent';
import { Separator } from '../../Separator';

import { StyledContent } from './styles';

type CanadianOptInProps = BindCheckbox & {
  disabled?: boolean;
  onContactUsClick?: () => void;
};

export function CanadianOptIn({ onContactUsClick, ...props }: CanadianOptInProps) {
  const { getContentByPath } = useContent();

  const contactUsClick = useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();
      onContactUsClick && onContactUsClick();
      window.open(CONTACT_US_URL);
    },
    [onContactUsClick],
  );

  const [subHeaderPreLink, subHeaderPostLink] = useMemo(
    () => getContentByPath<string>('shared.fields.canadianOptIn.subHeader').split('%mgmResorts%'),
    [getContentByPath],
  );

  const mgmResorts = useMemo(
    () => getContentByPath<string>('shared.fields.canadianOptIn.mgmResorts'),
    [getContentByPath],
  );
  const mgmResortsIncludingBetMGM = useMemo(
    () => getContentByPath<string>('shared.fields.canadianOptIn.mgmResortsIncludingBetMGM'),
    [getContentByPath],
  );

  const renderPolicyContent = useCallback(() => {
    const [optInPreLink, optInPostLink] = getContentByPath<string>('shared.fields.canadianOptIn.optIn').split(
      '%mgmResortsIncludingBetMGM%',
    );
    return (
      <Typography variant='body-regular-s'>
        {optInPreLink}
        <TextLink
          variant='small'
          href={CONTACT_US_URL}
          onClick={contactUsClick}
          data-testid='canadian-optin-contact-us'
        >
          {mgmResortsIncludingBetMGM}
        </TextLink>
        {optInPostLink}
      </Typography>
    );
  }, [contactUsClick, getContentByPath, mgmResortsIncludingBetMGM]);

  return (
    <StyledContent data-testid='canadian-optin'>
      <Typography variant='body-medium-xl' as='h5' className='identity__for-canadians-header'>
        {getContentByPath<string>('shared.fields.canadianOptIn.header')}
      </Typography>
      <Typography
        variant='body-regular-s'
        className='identity__for-canadians-sub-header'
        testId='canadian-optin-content'
      >
        {subHeaderPreLink}
        <TextLink variant='small' href={CONTACT_US_URL} onClick={contactUsClick}>
          {mgmResorts}
        </TextLink>
        {subHeaderPostLink}
      </Typography>
      <Checkbox
        variant='small'
        alignlabel='top'
        label={renderPolicyContent()}
        labelPosition='right'
        id='canadianOnpIn'
        {...props}
      />
      <Separator />
    </StyledContent>
  );
}
